/* eslint-disable import/no-duplicates */

// All common imports live here
import '../components/account/confirm-delete-component';
import '../components/account/enter-email-component';
import '../components/account/grant-access-component';
import '../components/account/signin-modal-component';
import '../components/admin/admin-categories-tags-fragment';
import '../components/admin/admin-style-settings-fragment';
import '../components/admin/admin-fragment-holder';
import '../components/admin/admin-points-list-fragment';
import '../components/admin/admin-points-upload-fragment';
import '../components/admin/admin-publish-fragment';
import '../components/admin/admin-share-settings-fragment';
import '../components/admin/map-sharing-component';
import '../components/send-map-to-phone-modal';
import '../components/admin/admin-advanced-features-fragment';
import '../components/admin/admin-addons-list-fragment';
import '../components/admin/admin-ai-point-generation-fragment';
import '../components/admin/addons/admin-challenge-addon';
import '../components/admin/addons/admin-guide-addon';
import '../components/admin/addons/admin-hunt-addon';
import '../components/admin/addons/admin-treasure-hunt-addon';
import '../components/admin/addons/admin-election-addon';
import '../components/admin/addons/admin-popup-addon';
import '../components/create-pop-up-component';
import '../components/existing-pop-ups-component';
import '../components/admin/addons/admin-collab-settings-addon';
import '../components/admin/addons/admin-comment-addon';
import '../components/admin/addons/admin-integration-automation-addon';
import '../components/admin/addons/admin-capture-emails-addon';
import '../components/admin/addons/admin-blog-to-map-ai-addon';
import '../components/admin/addons/admin-translation-addon';
import '../components/admin/addons/admin-zapier-integration-addon';
import '../components/admin/addons/admin-gated-access-addon';
import '../components/admin/addons/admin-paywall-addon';
import '../components/admin/addons/admin-zapier-integration-addon';
import '../components/admin/admin-addon-renderer';
import '../components/admin/style/header-colors';
import '../components/admin/style/map-orientation';
import '../components/admin/style/featured-point-color';
import '../components/admin/style/header-logo';
import '../components/admin/style/icon-settings';
import '../components/admin/style/map-overlay-editor';
import '../components/admin/style/map-skin';
import '../components/admin/style/rename-map';
import '../components/admin/style/hide-header';
import '../components/admin/core-settings/custom-urls';
import '../components/admin/core-settings/date-and-time';
import '../components/admin/core-settings/setting-component';
import '../components/admin/core-settings/add-point-customization-element';
import '../components/admin/core-settings/allow-upvoting';
import '../components/admin/core-settings/map-center-scale';
import '../components/admin/core-settings/marker-cluster-settings';
import '../components/admin/core-settings/point-approval';
import '../components/add-creator-profile-modal';
import '../components/add-edit-folder-modal';
import '../components/add-edit-point-component';
import '../components/add-maps-modal';
import '../components/add-point-button';
import '../components/backpack-cards';
import '../components/insight-cards';
import '../components/blog-feed-component';
import '../components/bookmark-map-modal';
import '../components/bookmark-map-button';
import '../components/creator-profile-form';
import '../components/creator-profile-card';
import '../components/crowdsourced-point-details';
import '../components/color-picker';
import '../components/confirm-dialog';
import '../components/copy-link-component';
import '../components/date-time-range-modal';
import '../components/advanced-filtering-modal';
// import '../components/admin-payment-settings';
import '../components/add-point-to-map-component';
import '../components/set-default-map-template-component';
import '../components/get-route-component';
import '../components/downloadable-error-toast';
import '../components/drawer-button-component';
import '../components/duplicate-map-component';
import '../components/edit-categories-tags';
import '../components/edit-challenge-rewards';
import '../components/edit-pop-up-component';
import '../components/edit-challenge-activities';
import '../components/edit-shape-modal';
import '../components/expanded-point-list';
import '../components/category-form';
import '../components/challenge-activity-form';
import '../components/challenge-reward-form';
import '../components/tag-form';
import '../components/email-capture-modal';
import '../components/election-form-component';
import '../components/comment-component';
import '../components/demographics-panel';
import '../components/emails-invite-component';
import '../components/error-page-fragment';
import '../components/error-toast';
import '../components/filter-chips';
import '../components/folder-selector';
import '../components/form-visibility-component';
import '../components/team-selector';
import '../components/backpack-sidebar';
import '../components/settings-sidebar';
import '../components/subscription-cards';
import '../components/topic-metadata';
import '../components/gpt-waiting-state';
import '../components/hot-points';
import '../components/onboarding-modal';
import '../components/onboarding-call-notification';
import '../components/organization-profile-popup';
import '../components/demographics-form';
import '../components/kml-upload-component';
import '../components/language-selector';
import '../components/leave-spreadsheet-modal';
import '../components/legend-component';
import '../components/cart-component';
import '../components/manage-folder-access-component';
import '../components/manage-team-access-component';
import '../components/map-component';
import '../components/static-map-component';
import '../components/static-map-embed-modal';
import '../components/nomination-component';
import '../components/mini-point-card';
import '../components/list-point-card';
import '../components/grid-point-card';
import '../components/basic-point-card';
import '../components/photo-feed-card';
import '../components/clue-point-card';
import '../components/clue-details-point-card';
import '../components/basic-activity-card';
import '../components/nearby-search-component';
import '../components/new-ui-banner';
import '../components/expanded-point-card';
import '../components/challenge-point-card';
import '../components/point-card-base';
import '../components/point-card-actions';
import '../components/booking-card';
import '../components/point-card-menu';
import '../components/point-card-pagination';
import '../components/point-card-wrapper';
import '../components/point-drawer';
import '../components/point-list';
import '../components/social-share-buttons';
import '../components/range-slider-component';
import '../components/image-upload-component';
import '../components/tabs-component';
import '../components/common/access-item';
import '../components/common/tags-categories-wrapper';
import '../components/common/challenge-rewards-wrapper';
import '../components/common/challenge-activity-wrapper';
import '../components/common/date-time-range-picker';
import '../components/common/map-header';
import '../components/common/point-input';
import '../components/common/proxi-autocomplete';
import '../components/common/map-drawer-component';
import '../components/common/proxi-input-place';
import '../components/common/geofence-map-picker';
import '../components/common/topic-center-input';
import '../components/common/rich-text-editor';
import '../components/common/professional-services-component';
import '../components/internal/bulk-reg-component';
import '../components/internal/reg-add-point-component';
import '../components/mobile/setting-drawer';
import '../components/mobile/setting-controls';
import '../components/mobile/setting-control-buttons';
import '../components/mobile/categories/tags-categories-wrapper';
import '../components/mobile/categories/tags-categories-item';
import '../components/nav-bar/context-menu';
import '../components/team-switch-menu';
import '../components/nav-bar/help-menu';
import '../components/nav-bar/nav-bar';
import '../components/theme/account-avatar';
import '../components/theme/backpack-card';
import '../components/theme/insight-card';
import '../components/theme/loading-element';
import '../components/theme/progress-element';
import '../components/theme/multi-user-avatar';
import '../components/theme/category-pill';
import '../components/theme/category-selector';
import '../components/theme/confirm-modal';
import '../components/theme/folder-accordion';
import '../components/theme/folder-card';
import '../components/theme/folder-menu';
import '../components/theme/form-button';
import '../components/theme/form-checkbox';
import '../components/theme/form-input';
import '../components/theme/form-input-access';
import '../components/theme/form-input-button';
import '../components/theme/form-switch';
import '../components/theme/form-textarea';
import '../components/theme/form-tooltip';
import '../components/theme/image-carousel';
import '../components/theme/modal-dialog';
import '../components/theme/modal-header';
import '../components/theme/proxi-textfield';
import '../components/theme/settings-card';
import '../components/theme/proxi-textarea';
import '../components/theme/proxi-selectfield';
import '../components/theme/proxi-selectfield-inline';
import '../components/theme/proxi-multi-selectfield';
import '../components/theme/translated-span';
import '../components/theme/tag-pill';
import '../components/theme/tags-selector';
import '../components/theme/topic-menu';
import '../components/theme/company-menu';
import '../components/upgrade-dialog';
import '../components/upgrade-cta';
import '../components/upgrade-div';
import '../components/wrappers/handsontable-element';
import '../components/checkin-challenge-component';
import '../components/active-challenge-button';
import '../components/assign-challenge-checkins-modal';
import '../components/challenge-locations-progress';
import '../components/challenge-approvals-section';
import '../components/challenge-participant-details-modal';
import '../components/challenge-leaderboard';
import '../components/challenge-photo-feed';
import '../components/past-scheduled-message-component';
import '../components/completed-purchases-component';
import '../components/existing-products-component';
import '../components/pre-checkout-component';
import './checkout-return-page';
import './subscription-details-page';
import '../components/create-message-component';
import '../components/create-product-component';
import '../components/webhook-management-component';
import '../components/challenge-participant-progress';
import '../components/challenge-participants-progress-modal';
import '../components/challenge-uncheck-confirm-modal';
import '../components/map-header-buttons';
import '../components/challenge-award-announcement';
import '../components/gated-access-insights-component';
import '../components/gated-access-select-points-modal';
import '../components/creator-info-component';
import '../helpers/state/point-cache';
import '../helpers/state/topic-data';
import '../helpers/state/drawing-tool';
import '../helpers/state/challenge-data';
import '../helpers/state/seo-data';
import '../helpers/state/translation-data';
import '../helpers/api/products-api';
import '../helpers/icon-loader';
import '@material/mwc-button';
import '@material/mwc-circular-progress';
import '@material/mwc-checkbox';
import '@material/mwc-dialog';
import '@material/mwc-icon';
import '@material/mwc-icon-button';
import '@material/mwc-fab';
import '@material/mwc-formfield';
import '@material/mwc-list/mwc-list-item';
import '@material/mwc-menu';
import '@material/mwc-select';
import '@material/mwc-textarea';
import '@material/mwc-textfield';
import '@johnriv/google-map/google-map';
import '@johnriv/google-map/google-map-marker';
import '@lit-labs/virtualizer';
import 'paper-chip';
import 'paper-input-place';
import '@polymer/iron-icon';
import '@polymer/paper-button';
import '@polymer/paper-card';
import '@polymer/paper-dialog/paper-dialog';
import '@polymer/paper-input/paper-input';
import '@polymer/paper-item/paper-item';
import '@polymer/paper-item/paper-item-body';
import '@polymer/paper-listbox/paper-listbox';
import '@polymer/paper-tooltip/paper-tooltip';
import '@polymer/paper-toast/paper-toast';
import '@turf/center';
import '@vaadin/vaadin-accordion';
import '@vaadin/combo-box';
import '@vaadin/vaadin-accordion/vaadin-accordion';
import '@vaadin/vaadin-accordion/vaadin-accordion-panel';
import '@vaadin/vaadin-date-picker';
import '@vaadin/vaadin-details';
import '@vaadin/vaadin-progress-bar';
import '@vaadin/vaadin-tabs';
import '@vaadin/vaadin-time-picker';
import '@vaadin/vaadin-upload';

import { LitElement, css, html, unsafeCSS } from 'lit';
import { customElement, query, state } from 'lit/decorators';
import { delay, isDefined } from '../helpers/utils';

import { DownloadableErrorToastElement } from '../components/downloadable-error-toast';
import { ErrorToastElement } from '../components/error-toast';
import { Router } from '../router';
import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import { palette } from '../style/variables';
import { storeReferralFromUrl } from '../helpers/api/referral-api';
import { hydrateFromSession } from '../helpers/auth-cookie';
import urlInfo from '../helpers/state/url-info';

export enum CalloutId {
    BackpackPageTitle = 'backpack-page-title',
    CreateMapButton = 'create-map-button',
    AIMapGeneration = 'ai-map-generation',
    TeamSettings = 'team-settings',
    WelcomeAfterCreatingMap = 'welcome-after-creating-map',
    SpreadsheetVideoTutorial = 'spreadsheet-video-tutorial',
    // Add more callout IDs as needed
}

export interface CalloutConfig {
    id: CalloutId | string;
    targetElement?: Element;
    type?: 'tooltip' | 'walkthrough' | 'callout';
    title?: string;
    content: string;
    links?: Array<{ text: string; url: string; external?: boolean }>;
    actions?: Array<{ text: string; handler: () => void; primary?: boolean }>;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'auto' | 'center';
    dismissible?: boolean;
    persistent?: boolean;
    priority?: number; // Higher number = higher priority (0-100)
    icon?: string;
    width?: string;
    backgroundImage?: string; // URL or path to background image
    currentStep?: number; // Current step in walkthrough (for progress dots)
    totalSteps?: number; // Total steps in walkthrough (for progress dots)
    onDismiss?: () => void;
}

@customElement('main-page')
export class MainPage extends LitElement {
    static amplitude_callsite: string = 'Main Page';
    private static readonly DISMISSED_CALLOUTS_KEY = 'dismissed-callouts';
    private static readonly MAX_VISIBLE_CALLOUTS = 5;

    @query('#errorToast')
    errorToastElement!: ErrorToastElement;

    @query('#downloadableErrorToast')
    downloadableErrorToastElement!: DownloadableErrorToastElement;

    @state()
    isReloading = false;

    @state()
    activeCallouts: CalloutConfig[] = [];

    private readonly bindAccountState = new StateController(this, accountInfo);

    /**
     * Check if a callout has been dismissed before
     */
    isCalloutDismissed(id: CalloutId | string): boolean {
        try {
            const dismissed = localStorage.getItem(MainPage.DISMISSED_CALLOUTS_KEY);
            if (!dismissed) return false;
            const dismissedSet = new Set<string>(JSON.parse(dismissed));
            return dismissedSet.has(id);
        } catch (error) {
            console.error('Failed to check dismissed callouts:', error);
            return false;
        }
    }

    /**
     * Mark a callout as dismissed in localStorage
     */
    markCalloutDismissed(id: CalloutId | string): void {
        try {
            const dismissed = localStorage.getItem(MainPage.DISMISSED_CALLOUTS_KEY);
            const dismissedSet = new Set<string>(dismissed ? JSON.parse(dismissed) : []);
            dismissedSet.add(id);
            localStorage.setItem(MainPage.DISMISSED_CALLOUTS_KEY, JSON.stringify(Array.from(dismissedSet)));
        } catch (error) {
            console.error('Failed to save dismissed callout:', error);
        }
    }

    /**
     * Get count of currently visible callouts
     */
    private getVisibleCalloutCount(): number {
        return this.activeCallouts.length;
    }

    /**
     * Show a callout, tooltip, or walkthrough element attached to a DOM element
     * @param config - Configuration for the callout
     * @returns The callout ID for later dismissal
     */
    showCallout(config: CalloutConfig): string {

        // Skip if callout was previously dismissed
        if (this.isCalloutDismissed(config.id)) {
            return config.id;
        }

        // Remove existing callout with same ID if it exists
        this.activeCallouts = this.activeCallouts.filter(c => c.id !== config.id);

        // Add new callout with defaults
        const newCallout: CalloutConfig = {
            type: 'callout',
            position: 'auto',
            dismissible: true,
            persistent: false,
            priority: 50, // Default priority
            ...config
        };

        this.activeCallouts = [...this.activeCallouts, newCallout];

        // Sort by priority (higher first) and limit to MAX_VISIBLE_CALLOUTS
        this.activeCallouts = this.activeCallouts
            .sort((a, b) => (b.priority ?? 50) - (a.priority ?? 50))
            .slice(0, MainPage.MAX_VISIBLE_CALLOUTS);

        // Force re-render
        this.requestUpdate();

        return config.id;
    }

    /**
     * Dismiss a specific callout by ID and optionally save to localStorage
     * @param id - The callout ID to dismiss
     * @param persist - Whether to save dismissal to localStorage (default: true)
     */
    dismissCallout(id: CalloutId | string, persist: boolean = true): void {
        const callout = this.activeCallouts.find(c => c.id === id);

        // Remove highlight from target element
        if (callout?.targetElement && callout.position !== 'center') {
            const target = callout.targetElement as HTMLElement;
            // Restore original styles
            target.style.outline = (target as any)._originalOutline ?? '';
            target.style.boxShadow = (target as any)._originalBoxShadow ?? '';
            target.style.outlineOffset = '';
            target.style.borderRadius = '';
            delete (target as any)._originalOutline;
            delete (target as any)._originalBoxShadow;
        }

        if (callout?.onDismiss) {
            callout.onDismiss();
        }

        // Mark as dismissed in localStorage only if persist is true
        if (persist) {
            this.markCalloutDismissed(id);
        }
        this.activeCallouts = this.activeCallouts.filter(c => c.id !== id);
    }

    /**
     * Dismiss all callouts
     */
    dismissAllCallouts(): void {
        this.activeCallouts.forEach(callout => {
            // Remove highlight from target element
            if (callout.targetElement && callout.position !== 'center') {
                const target = callout.targetElement as HTMLElement;
                // Restore original styles
                target.style.outline = (target as any)._originalOutline ?? '';
                target.style.boxShadow = (target as any)._originalBoxShadow ?? '';
                target.style.outlineOffset = '';
                target.style.borderRadius = '';
                delete (target as any)._originalOutline;
                delete (target as any)._originalBoxShadow;
            }

            if (callout.onDismiss) {
                callout.onDismiss();
            }
        });
        this.activeCallouts = [];
    }

    /**
     * Check if a callout is currently active
     */
    isCalloutActive(id: CalloutId | string): boolean {
        return this.activeCallouts.some(c => c.id === id);
    }

    protected async firstUpdated() {
        window.onhashchange = () => {
            this.requestUpdate();
            // Check for referral on hash change (fire and forget, don't block UI)
            void storeReferralFromUrl(window.location.href);
        };

        // A sign-in made on app.proxi.co: store it, then start over so every
        // component that already read "signed out" sees the real state.
        if (await hydrateFromSession()) {
            window.location.reload();
            return;
        }

        await accountInfo.instantiateAccountData();
        await urlInfo.instantiateCustomUrlData();

        // Check for referral on initial page load (fire and forget, don't block UI)
        void storeReferralFromUrl(window.location.href);

        // Listen for pages to signal they're ready, with a fallback timeout
        // so the loading screen always eventually hides
        window.addEventListener('page-content-ready', () => this.hideLoadingScreen(), { once: true });
        this.loadingScreenTimeout = window.setTimeout(() => this.hideLoadingScreen(), 5000);
    }

    private loadingScreenTimeout?: number;

    hideLoadingScreen() {
        if (this.loadingScreenTimeout !== undefined) {
            clearTimeout(this.loadingScreenTimeout);
            this.loadingScreenTimeout = undefined;
        }
        const loadingScreen = document.querySelector('.loading-screen');
        if (loadingScreen) {
            loadingScreen.classList.add('hidden');
        }
    }

    private showLoadingScreen() {
        const loadingScreen = document.querySelector('.loading-screen');
        if (loadingScreen) {
            loadingScreen.classList.remove('hidden');
        }
    }

    async reload(postReloadMessage?: string) {
        this.isReloading = true;
        this.showLoadingScreen();
        this.requestUpdate();

        await delay(0);

        this.isReloading = false;
        this.requestUpdate();
        await delay(500);
        if (postReloadMessage) {
            this.errorToastElement.showToast(postReloadMessage);
        }
        this.hideLoadingScreen();
    }

    render() {
        if (this.isReloading || !accountInfo.isReady) {
            return html``;
        }

        this.style.setProperty('--custom-font', 'Montserrat');

        return html`
            ${Router.getContent()}
            ${this.renderCallouts()}
            <error-toast id="errorToast"></error-toast>
            <downloadable-error-toast id="downloadableErrorToast"></downloadable-error-toast>
        `;
    }

    private renderCallouts() {
        return this.activeCallouts.map((callout, index) => {
            const isCentered = callout.position === 'center';
            const isTooltip = callout.type === 'tooltip';

            // For centered callouts, we don't need a target element
            let target: Element | undefined;
            if (!isCentered) {
                target = callout.targetElement ?? undefined;

                if (!target) {
                    console.warn(`⚠️ [CALLOUT] Target element not found for callout: "${callout.id}"`);
                    return html``;
                }

                // Add inline styles for highlight effect (works across shadow DOM)
                const originalOutline = (target as HTMLElement).style.outline;
                const originalBoxShadow = (target as HTMLElement).style.boxShadow;
                (target as HTMLElement).style.outline = '3px solid blue';
                (target as HTMLElement).style.outlineOffset = '4px';
                (target as HTMLElement).style.borderRadius = '8px';
                (target as HTMLElement).style.transition = 'all 0.3s ease';

                // Store original styles to restore later
                (target as any)._originalOutline = originalOutline;
                (target as any)._originalBoxShadow = originalBoxShadow;
            }

            // Calculate positioning based on type and position
            let containerPosition: { top: number; left: number };
            let fullPosition: { top: number; left: number; arrowPosition: string } | null = null;

            if (isCentered) {
                // Center the callout on screen
                const calloutWidth = parseInt(callout.width ?? '300');
                containerPosition = {
                    top: (window.innerHeight / 2) - 150, // Approximate half height of callout
                    left: (window.innerWidth / 2) - (calloutWidth / 2)
                };
                // No arrow for centered callouts
                fullPosition = null;
            } else if (target) {
                const rect = target.getBoundingClientRect();
                // For all non-centered callouts: calculate position and arrow
                fullPosition = this.calculateCalloutPosition(rect, callout.position ?? 'auto', callout.width, !!callout.backgroundImage);
                containerPosition = { top: fullPosition.top, left: fullPosition.left };

                // For tooltips: adjust container to show dot at target location
                if (isTooltip) {
                    containerPosition = {
                        top: rect.top + (rect.height / 2) - 6,
                        left: rect.right + 8
                    };
                }
            } else {
                // Fallback (should never reach here)
                containerPosition = { top: 100, left: 100 };
            }

            return html`
                <div
                    class="callout-container ${callout.type ?? 'callout'}"
                    style="
                        top: ${containerPosition.top}px;
                        left: ${containerPosition.left}px;
                    "
                >
                    ${isTooltip ? html`
                        <div class="callout-dot">
                            <span class="callout-dot-pulse"></span>
                        </div>
                    ` : ''}
                    <div class="callout-overlay ${callout.type ?? 'callout'}" style="width: ${callout.width ?? '300px'}; ${callout.backgroundImage ? 'padding-top: 136px;' : ''}">
                        ${callout.backgroundImage ? html`
                            <div class="callout-background" style="background-image: url('${callout.backgroundImage}');"></div>
                        ` : ''}
                        <div class="callout-content" style="position: relative; z-index: 2;">
                        ${callout.dismissible === true ? html`
                            <mwc-icon
                                class="callout-close"
                                @click="${() => this.dismissCallout(callout.id)}"
                            >close</mwc-icon>
                        ` : ''}

                        ${callout.icon ? html`
                            <div class="callout-icon">${callout.icon}</div>
                        ` : ''}

                        ${callout.title ? html`
                            <h4 class="callout-title">${callout.title}</h4>
                        ` : ''}

                        <div class="callout-text">${callout.content}</div>

                        ${callout.links && callout.links.length > 0 ? html`
                            <div class="callout-links">
                                ${callout.links.map(link => html`
                                    <a
                                        href="${link.url}"
                                        target="${isDefined(link.external) ? '_blank' : '_self'}"
                                        rel="${isDefined(link.external) ? 'noopener noreferrer' : ''}"
                                        class="callout-link"
                                    >
                                        ${link.text} ${isDefined(link.external) ? '🔗' : ''}
                                    </a>
                                `)}
                            </div>
                        ` : ''}

                        ${callout.type === 'walkthrough' && isDefined(callout.currentStep) && isDefined(callout.totalSteps) ? html`
                            <div class="step-indicators">
                                ${Array.from({ length: callout.totalSteps }, (_, i) => html`
                                    <div class="step-dot ${i === callout.currentStep ? 'active' : ''}"></div>
                                `)}
                            </div>
                        ` : ''}

                        ${callout.actions && callout.actions.length > 0 ? html`
                            <div class="callout-actions">
                                ${callout.actions.map(action => html`
                                    <form-button
                                        class="${isDefined(action.primary) ? 'primary' : 'secondary'}"
                                        @click="${action.handler}"
                                        size="sm"
                                    >
                                        ${action.text}
                                    </form-button>
                                `)}
                            </div>
                        ` : ''}
                        </div>
                    </div>
                </div>
            `;
        });
    }

    private calculateCalloutPosition(targetRect: DOMRect, position: string, width?: string, hasBackgroundImage: boolean = false) {
        const calloutWidth = parseInt(width ?? '300');
        const offset = 12;

        // Estimate callout height based on content
        const baseHeight = 200; // Base height for content
        const backgroundImageHeight = hasBackgroundImage ? 136 : 0; // Extra height if background image
        const estimatedHeight = baseHeight + backgroundImageHeight;

        let top = 0;
        let left = 0;
        let arrowPosition = 'bottom';

        switch (position) {
            case 'center':
                // Center on screen (no arrow)
                top = (window.innerHeight / 2) - (estimatedHeight / 2);
                left = (window.innerWidth / 2) - (calloutWidth / 2);
                arrowPosition = 'none';
                break;
            case 'top':
                top = targetRect.top - offset - estimatedHeight;
                left = targetRect.left + (targetRect.width / 2) - (calloutWidth / 2);
                arrowPosition = 'bottom';
                break;
            case 'bottom':
                top = targetRect.bottom + offset;
                left = targetRect.left + (targetRect.width / 2) - (calloutWidth / 2);
                arrowPosition = 'top';
                break;
            case 'left':
                top = targetRect.top + (targetRect.height / 2) - (estimatedHeight / 2);
                left = targetRect.left - calloutWidth - offset;
                arrowPosition = 'right';
                break;
            case 'right':
                top = targetRect.top + (targetRect.height / 2) - (estimatedHeight / 2);
                left = targetRect.right + offset;
                arrowPosition = 'left';
                break;
            default: // auto
                // Choose best position based on available space
                if (targetRect.bottom + estimatedHeight < window.innerHeight) {
                    top = targetRect.bottom + offset;
                    left = targetRect.left + (targetRect.width / 2) - (calloutWidth / 2);
                    arrowPosition = 'top';
                } else if (targetRect.top - estimatedHeight > 0) {
                    top = targetRect.top - offset - estimatedHeight;
                    left = targetRect.left + (targetRect.width / 2) - (calloutWidth / 2);
                    arrowPosition = 'bottom';
                } else if (targetRect.right + calloutWidth < window.innerWidth) {
                    top = targetRect.top + (targetRect.height / 2) - (estimatedHeight / 2);
                    left = targetRect.right + offset;
                    arrowPosition = 'left';
                } else if (targetRect.left - calloutWidth > 0) {
                    top = targetRect.top + (targetRect.height / 2) - (estimatedHeight / 2);
                    left = targetRect.left - calloutWidth - offset;
                    arrowPosition = 'right';
                } else {
                    // Last resort: center on screen
                    top = (window.innerHeight / 2) - (estimatedHeight / 2);
                    left = (window.innerWidth / 2) - (calloutWidth / 2);
                    arrowPosition = 'top';
                }
        }

        // Keep within viewport with proper padding
        const padding = 10;
        left = Math.max(padding, Math.min(left, window.innerWidth - calloutWidth - padding));
        top = Math.max(padding, Math.min(top, window.innerHeight - estimatedHeight - padding));

        return { top, left, arrowPosition };
    }

    private getArrowStyle(position: string): string {
        // Return data attribute for CSS-based arrow styling
        return `data-position="${position}"`;
    }

    static get styles() {
        return css`
            :root {
                --custom-font: 'Montserrat'
            }

            :host {
                --main-font: var(--custom-font), 'Montserrat', sans-serif;
                font-family: var(--main-font), 'Montserrat', sans-serif;
                --paper-input-container-shared-input-style_-_font-family: var(--main-font), 'Montserrat', sans-serif;
                --paper-font-subhead_-_font-family: var(--main-font), 'Montserrat', sans-serif;
                --mdc-typography-font-family: var(--main-font), 'Montserrat', sans-serif !important;
                --mdc-typography-body1-font-family: var(--main-font), 'Montserrat', sans-serif !important;
                --lumo-font-family: var(--main-font), 'Montserrat', sans-serif !important;
                --paper-font-common-base_-_font-family: var(--main-font), 'Montserrat', sans-serif !important;
                --mdc-notched-outline-border-color: var(--main-primary-color);
                --mdc-select-outlined-idle-border-color: var(--main-primary-color);

                --main-primary-color: ${unsafeCSS(palette.primaryBlue)};
                --main-primary-opacity-color: ${unsafeCSS(palette.primaryOpacity)};
                --main-secondary-color: ${unsafeCSS(palette.aquaBlue)};
                --main-invalid-color: ${unsafeCSS(palette.failureRed)};
                --main-warning-color: ${unsafeCSS(palette.lightRed)};
                --main-success-color: ${unsafeCSS(palette.successGreen)};
                --main-moon-color: ${unsafeCSS(palette.accentMoon)};
                --main-featured-color: ${unsafeCSS(palette.accentFeatured)};
                --main-sky-color: ${unsafeCSS(palette.accentSky)};
                --main-sand-color: ${unsafeCSS(palette.accentSand)};
                --main-surf-color: ${unsafeCSS(palette.accentSurf)};
                --main-special-offer-color: ${unsafeCSS(palette.specialOfferColor)};

                --theme-primary-text-color: ${unsafeCSS(palette.primaryText)};
                --theme-primary-text-color: ${unsafeCSS(palette.lightText)};
                --theme-primary-text-color: ${unsafeCSS(palette.lighterText)};
                --theme-lightest-color: ${unsafeCSS(palette.lightestText)};
                --theme-input-color: ${unsafeCSS(palette.inputText)};
                --theme-input-border-color: ${unsafeCSS(palette.inputBorder)};
                --theme-focus-border-color: ${unsafeCSS(palette.focusBorder)};
                --theme-border-color: ${unsafeCSS(palette.lightBorder)};
                --theme-checkbox-color: ${unsafeCSS(palette.checkboxColor)};
                --theme-white-color: ${unsafeCSS(palette.whiteColor)};
                --theme-light-scrollbar-color: ${unsafeCSS(palette.lightScrollbar)};
                --theme-opacity-background-color: ${unsafeCSS(palette.opacityBackground)};
                --theme-overlay-background-color: ${unsafeCSS(palette.overlayBackground)};

                color: var(--theme-input-color);
                --mdc-theme-primary: var(--main-primary-color);
                --mdc-dialog-content-ink-color: var(--theme-input-color);
                --mdc-shape-medium: 0.75rem;
                --mdc-dialog-max-width: 80vw;
                --mdc-dialog-max-height: 80vh;

                font-size: 12px;
                touch-action: none;
            }

            button {
                color: var(--theme-input-color);
                background-color: var(--main-primary-color);
                border-radius: 0.25rem;
            }

            @media only screen and (max-width: 550px) {
                :host {
                    --mdc-dialog-max-height: 70%;
                }
            }

            .callout-container {
                position: fixed;
                z-index: 10000;
            }

            .callout-dot {
                width: 12px;
                height: 12px;
                background: var(--main-primary-color);
                border-radius: 50%;
                cursor: pointer;
                position: relative;
                animation: calloutFadeIn 0.3s ease-in-out;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            }

            .callout-dot-pulse {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: var(--main-primary-color);
                animation: pulse 2s ease-out infinite;
            }

            @keyframes pulse {
                0% {
                    opacity: 1;
                    transform: translate(-50%, -50%) scale(1);
                }
                100% {
                    opacity: 0;
                    transform: translate(-50%, -50%) scale(2.5);
                }
            }

            .callout-container.tooltip .callout-overlay {
                display: none;
                position: absolute;
                top: -8px;
                left: 20px;
            }

            .callout-container.tooltip:hover .callout-overlay,
            .callout-container.tooltip .callout-overlay:hover {
                display: block;
            }

            .callout-overlay {
                background: white;
                border-radius: 8px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
                padding: 16px;
                animation: calloutFadeIn 0.3s ease-in-out;
                position: relative;
                overflow: hidden;
            }

            .callout-background {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 120px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: 8px 8px 0 0;
                z-index: 1;
            }

            .callout-overlay.tooltip {
                padding: 8px 12px;
                font-size: 12px;
                max-width: 200px;
                min-width: 150px;
            }

            .callout-overlay.walkthrough {
                box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
            }

            .callout-content {
                text-align: center;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .callout-close {
                position: absolute;
                top: -8px;
                right: -8px;
                cursor: pointer;
                color: var(--theme-input-color);
                font-size: 18px;
                transition: color 0.2s;
            }

            .callout-close:hover {
                color: var(--main-invalid-color);
            }

            .callout-icon {
                font-size: 24px;
                margin-bottom: 8px;
            }

            .callout-title {
                margin: 0 0 8px 0;
                font-size: 16px;
                font-weight: 600;
                color: var(--theme-input-color);
            }

            .callout-text {
                font-size: .75rem;
                line-height: 1;
                color: var(--theme-input-color);
                text-align: center;
                padding: 8px;
            }

            .callout-links {
                display: flex;
                flex-direction: column;
                gap: 8px;
                margin-bottom: 12px;
            }

            .callout-link {
                color: var(--main-primary-color);
                text-decoration: none;
                font-size: 13px;
                font-weight: 500;
                transition: opacity 0.2s;
            }

            .callout-link:hover {
                opacity: 0.7;
                text-decoration: underline;
            }

            .callout-actions {
                display: flex;
                gap: 8px;
                justify-content: center;
                margin-top: 12px;
                flex-wrap: wrap;
                align-items: center;
            }

            .callout-actions mwc-button {
                --mdc-theme-primary: var(--main-primary-color);
            }

            .step-indicators {
                display: flex;
                gap: 8px;
                justify-content: center;
                margin-top: 16px;
                margin-bottom: 8px;
            }

            .step-dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #d0d0d0;
                transition: all 0.3s ease;
            }

            .step-dot.active {
                background: var(--main-primary-color);
                width: 24px;
                border-radius: 4px;
            }

            .callout-target-highlight {
                outline: 3px solid var(--main-primary-color) !important;
                outline-offset: 4px;
                border-radius: 8px;
                box-shadow: 0 0 0 4px rgba(68, 138, 255, 0.2) !important;
                animation: pulseOutline 2s ease-in-out infinite;
                transition: all 0.3s ease;
            }

            @keyframes pulseOutline {
                0%, 100% {
                    outline-color: var(--main-primary-color);
                    box-shadow: 0 0 0 4px rgba(68, 138, 255, 0.3);
                }
                50% {
                    outline-color: var(--main-primary-opacity-color);
                    box-shadow: 0 0 0 8px rgba(68, 138, 255, 0.1);
                }
            }

            .callout-actions mwc-button.secondary {
                --mdc-theme-primary: var(--theme-input-color);
            }

            .callout-arrow {
                position: absolute;
                width: 0;
                height: 0;
                border: 10px solid transparent;
            }

            .callout-arrow[data-position="top"] {
                top: -10px;
                left: 50%;
                transform: translateX(-50%);
                border-bottom-color: white;
                border-top: none;
            }

            .callout-arrow[data-position="bottom"] {
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                border-top-color: white;
                border-bottom: none;
            }

            .callout-arrow[data-position="left"] {
                left: -10px;
                top: 50%;
                transform: translateY(-50%);
                border-right-color: white;
                border-left: none;
            }

            .callout-arrow[data-position="right"] {
                right: -10px;
                top: 50%;
                transform: translateY(-50%);
                border-left-color: white;
                border-right: none;
            }

            @keyframes calloutFadeIn {
                from {
                    opacity: 0;
                    transform: scale(0.95);
                }
                to {
                    opacity: 1;
                    transform: scale(1);
                }
            }
        `;
    }
}


declare global {
    interface Array<T> {
        // eslint-disable-next-line @typescript-eslint/method-signature-style
        sortBy<P extends number | string>(selector: (o: T) => P, direction?: number): T[];
    }
}

// eslint-disable-next-line no-extend-native
Array.prototype.sortBy = function (selector, direction = 1) {
    return this.sort((a, b) => {
        if (selector(a) > selector(b)) return direction * -1;
        if (selector(b) > selector(a)) return direction * 1;
        return 0;
    });
};

